
  import { defineComponent } from 'vue';
  import { AppDynamicIcon } from '@/components';
  import { courseTypeIcons } from '.';

  import type { Component, PropType } from 'vue';
  import type { DynamicIcon } from '@/components/AppDynamicIcon';
  import type { Course } from '@/views/Courses/List';

  export default defineComponent({
    name: 'AppCourseTypeIcon',

    components: {
      AppDynamicIcon,
    },

    props: {
      course: {
        type: Object as PropType<Course>,
        required: true,
      },
    },

    computed: {
      courseTypeIcon(): DynamicIcon | Component | undefined {
        return courseTypeIcons[this.course.courseTypeKey];
      },
    },
  });
